import React from 'react';

import { MenuItem } from '@mui/material';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import dropdownItemStyles from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/dropdownStyling.module.scss';
import { CustomizedDropdownMenu, CustomizedRoundIcon } from 'components/common';

const displayValues = {
    completedOverrunRatioTypical: 'Highest P50 Ratio',
    completedOverrunRatioHigh: 'Highest P80 Ratio',
    completedOverrunDaysTypical: 'Highest P50 Overrun (days)',
    completedOverrunDaysHigh: 'Highest P80 Overrun (days)',
    clusterName: 'Cluster Name (alphabetic order)',
};

export type TClusterSortBy = keyof typeof displayValues;

interface ISortSelectProps {
    setClusterSortBy: (value: TClusterSortBy) => void;
    clusterSortBy: TClusterSortBy;
}

export const SortSelect = ({ setClusterSortBy, clusterSortBy }: ISortSelectProps) => {
    const handleClusterClick = (newSortProperty) => {
        setClusterSortBy(newSortProperty);
    };

    const AllDropdownItems = Object.keys(displayValues).map((key) => {
        return (
            <MenuItem
                key={key}
                className={clusterSortBy === key ? dropdownItemStyles.selected : ''}
                onClick={() => handleClusterClick(key)}
                selected={clusterSortBy === key}
            >
                {displayValues[key]}
            </MenuItem>
        );
    });

    const title = displayValues[clusterSortBy];

    return (
        <CustomizedDropdownMenu
            triggerElement={
                <CustomizedRoundIcon size={'30px'} title={title}>
                    <MuiIcon icon={'filter_list'} />
                </CustomizedRoundIcon>
            }
        >
            {AllDropdownItems}
        </CustomizedDropdownMenu>
    );
};
